import React from 'react';
import { StackHeaderLeftButtonProps } from '@react-navigation/stack/src/types';
import styled from 'styled-components/native';

import Image from '@src/components/Image';

const Content = styled(Image)`
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 3px;
  width: 24px;
  height: 24px;
  resize-mode: contain;
`;

const headerBackImage: StackHeaderLeftButtonProps['backImage'] = ({
  tintColor,
}) => <Content source={require('@src/assets/images/arrow-right.png')} />;

export default headerBackImage;
